import type { Page } from "./pagesTypes";

/** Resolve numeric webpage id for legacy v1 structure routes (`/webpages/{id}/...`). */
export function getLegacyWebpageIdForStructure(
  pages: Page[],
  activeUuid: string | null
): number | null {
  if (!activeUuid) {
    return null;
  }
  const page = pages.find((p) => p.uuid === activeUuid);
  return page?.id != null && page.id > 0 ? page.id : null;
}

export function findPageByUuid(
  pages: Page[],
  uuid: string | null | undefined
): Page | undefined {
  if (!uuid) {
    return undefined;
  }
  return pages.find((p) => p.uuid === uuid);
}
